import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var langData = {
  meta: {},
  markup: {
    a: ['html', 'xml', 'svg', 'mathml']
  },
  css: {
    p: 'markup'
  },
  clike: {},
  javascript: {
    p: 'markup',
    r: 'clike',
    a: 'js'
  },
  abap: {},
  abnf: {},
  actionscript: {
    p: 'markup',
    r: 'javascript'
  },
  ada: {},
  apacheconf: {},
  apl: {},
  applescript: {},
  arduino: {
    r: 'cpp'
  },
  arff: {},
  asciidoc: {
    a: 'adoc'
  },
  asm6502: {},
  aspnet: {
    r: ['markup', 'csharp']
  },
  autohotkey: {},
  autoit: {},
  bash: {
    a: 'shell'
  },
  basic: {},
  batch: {},
  bison: {
    r: 'c'
  },
  bnf: {
    a: 'rbnf'
  },
  brainfuck: {},
  bro: {},
  c: {
    r: 'clike'
  },
  csharp: {
    r: 'clike',
    a: ['cs', 'dotnet']
  },
  cpp: {
    r: 'c'
  },
  cil: {},
  coffeescript: {
    r: 'javascript',
    a: 'coffee'
  },
  cmake: {},
  clojure: {},
  crystal: {
    r: 'ruby'
  },
  csp: {},
  'css-extras': {
    r: 'css'
  },
  d: {
    r: 'clike'
  },
  dart: {
    r: 'clike'
  },
  diff: {},
  django: {
    r: 'markup-templating',
    a: 'jinja2'
  },
  'dns-zone-file': {
    a: 'dns-zone'
  },
  docker: {
    a: 'dockerfile'
  },
  ebnf: {},
  eiffel: {},
  ejs: {
    r: ['javascript', 'markup-templating']
  },
  elixir: {},
  elm: {},
  erb: {
    r: ['ruby', 'markup-templating']
  },
  erlang: {},
  fsharp: {
    r: 'clike'
  },
  flow: {
    r: 'javascript'
  },
  fortran: {},
  gcode: {},
  gedcom: {},
  gherkin: {},
  git: {},
  glsl: {
    r: 'clike'
  },
  gml: {
    r: 'clike',
    a: 'gamemakerlanguage'
  },
  go: {
    r: 'clike'
  },
  graphql: {},
  groovy: {
    r: 'clike'
  },
  haml: {
    p: ['css', 'coffeescript', 'erb', 'javascript', 'less', 'markdown', 'ruby', 'scss', 'textile'],
    r: 'ruby'
  },
  handlebars: {
    r: 'markup-templating'
  },
  haskell: {
    a: 'hs'
  },
  haxe: {
    r: 'clike'
  },
  hcl: {},
  http: {
    p: ['javascript', 'markup']
  },
  hpkp: {},
  hsts: {},
  ichigojam: {},
  icon: {},
  inform7: {},
  ini: {},
  io: {},
  j: {},
  java: {
    r: 'clike'
  },
  javadoc: {
    p: ['scala'],
    r: ['markup', 'java', 'javadoclike']
  },
  javadoclike: {
    p: ['java', 'javascript', 'php']
  },
  javastacktrace: {},
  jolie: {
    r: 'clike'
  },
  jq: {},
  jsdoc: {
    p: ['actionscript', 'coffeescript'],
    r: ['javascript', 'javadoclike']
  },
  'js-extras': {
    p: ['actionscript', 'coffeescript', 'flow', 'n4js', 'typescript'],
    r: 'javascript'
  },
  'js-templates': {
    p: ['css', 'css-extras', 'graphql', 'markdown', 'markup'],
    r: 'javascript'
  },
  json: {},
  jsonp: {
    r: 'json'
  },
  json5: {
    r: 'json'
  },
  julia: {},
  keyman: {},
  kotlin: {
    r: 'clike'
  },
  latex: {
    a: ['tex', 'context']
  },
  less: {
    r: 'css'
  },
  lilypond: {
    r: 'scheme',
    a: 'ly'
  },
  liquid: {},
  lisp: {
    a: ['emacs', 'elisp', 'emacs-lisp']
  },
  livescript: {},
  lolcode: {},
  lua: {},
  makefile: {},
  markdown: {
    r: 'markup',
    a: 'md'
  },
  'markup-templating': {
    r: 'markup'
  },
  matlab: {},
  mel: {},
  mizar: {},
  monkey: {},
  n1ql: {},
  n4js: {
    p: ['jsdoc'],
    r: 'javascript',
    a: 'n4jsd'
  },
  'nand2tetris-hdl': {},
  nasm: {},
  nginx: {
    r: 'clike'
  },
  nim: {},
  nix: {},
  nsis: {},
  objectivec: {
    r: 'c'
  },
  ocaml: {},
  opencl: {
    p: ['c', 'cpp'],
    r: 'cpp'
  },
  oz: {},
  parigp: {},
  parser: {
    r: 'markup'
  },
  pascal: {
    a: 'objectpascal'
  },
  pascaligo: {},
  pcaxis: {
    a: 'px'
  },
  perl: {},
  php: {
    r: ['clike', 'markup-templating']
  },
  phpdoc: {
    r: ['php', 'javadoclike']
  },
  'php-extras': {
    r: 'php'
  },
  plsql: {
    r: 'sql'
  },
  powershell: {},
  processing: {
    r: 'clike'
  },
  prolog: {},
  properties: {},
  protobuf: {
    r: 'clike'
  },
  pug: {
    p: ['coffeescript', 'ejs', 'handlebars', 'less', 'livescript', 'markdown', 'scss', 'stylus', 'twig'],
    r: ['markup', 'javascript']
  },
  puppet: {},
  pure: {
    p: ['c', 'cpp', 'fortran']
  },
  python: {
    a: 'py'
  },
  q: {},
  qore: {
    r: 'clike'
  },
  r: {},
  jsx: {
    p: ['jsdoc', 'js-extras', 'js-templates'],
    r: ['markup', 'javascript']
  },
  tsx: {
    r: ['jsx', 'typescript']
  },
  renpy: {},
  reason: {
    r: 'clike'
  },
  regex: {
    p: ['actionscript', 'coffeescript', 'flow', 'javascript', 'typescript', 'vala']
  },
  rest: {},
  rip: {},
  roboconf: {},
  ruby: {
    r: 'clike',
    a: 'rb'
  },
  rust: {},
  sas: {},
  sass: {
    r: 'css'
  },
  scss: {
    r: 'css'
  },
  scala: {
    r: 'java'
  },
  scheme: {},
  'shell-session': {
    r: 'bash'
  },
  smalltalk: {},
  smarty: {
    r: 'markup-templating'
  },
  soy: {
    r: 'markup-templating'
  },
  'splunk-spl': {},
  sql: {},
  stylus: {},
  swift: {
    r: 'clike'
  },
  tap: {
    r: 'yaml'
  },
  tcl: {},
  textile: {
    p: 'css',
    r: 'markup'
  },
  toml: {},
  tt2: {
    r: ['clike', 'markup-templating']
  },
  twig: {
    r: 'markup'
  },
  typescript: {
    p: 'js-templates',
    r: 'javascript',
    a: 'ts'
  },
  't4-cs': {
    r: ['t4-templating', 'csharp'],
    a: 't4'
  },
  't4-vb': {
    r: ['t4-templating', 'visual-basic']
  },
  't4-templating': {},
  vala: {
    r: 'clike'
  },
  vbnet: {
    r: 'basic'
  },
  velocity: {
    r: 'markup'
  },
  verilog: {},
  vhdl: {},
  vim: {},
  'visual-basic': {
    a: 'vb'
  },
  wasm: {},
  wiki: {
    r: 'markup'
  },
  xeora: {
    r: 'markup',
    a: 'xeoracube'
  },
  xojo: {},
  xquery: {
    r: 'markup'
  },
  yaml: {
    a: 'yml'
  }
};
export function loadLang(_x) {
  return _loadLang.apply(this, arguments);
}

function _loadLang() {
  _loadLang = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ext) {
    var langs;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            langs = [];
            Object.keys(langData).forEach(function (item) {
              var _langData$item = langData[item],
                  alias = _langData$item.a,
                  require = _langData$item.r;

              if (alias && (Array.isArray(alias) ? alias : [alias]).includes(ext)) {
                if (require) {
                  langs = Array.from(new Set([].concat(_toConsumableArray(langs), _toConsumableArray(Array.isArray(require) ? require : [require]))));
                }
              }

              if (ext === item) {
                if (require) {
                  langs = Array.from(new Set([].concat(_toConsumableArray(langs), _toConsumableArray(Array.isArray(require) ? require : [require]))));
                }

                langs.push(ext);
              }
            });
            _context.prev = 2;

            if (!(langs.length > 0)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", Promise.all(langs.map(function (key) {
              return import("prismjs/components/prism-".concat(key));
            })));

          case 5:
            _context.next = 9;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 7]]);
  }));
  return _loadLang.apply(this, arguments);
}

export default langData;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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